/**
 * Determines whether a specific download option should be displayed based on user permissions and company settings
 *
 * @param {string} option - The option to check
 * @param {object} userData - User data containing permissions and role information
 * @param {object} companyInfo - Company settings and configuration data
 * @param {object} featureFlags - System feature flags
 * @param {number} candidateStatus - Current status of the candidate
 * @param {boolean} isBulkAction - Whether this is being used in a bulk action context
 * @returns {boolean} - True if the option should be shown, false otherwise
 */
export const shouldOptionShow = (
  option,
  userData,
  companyInfo,
  featureFlags,
  candidateStatus,
  isBulkAction
) => {
  switch (option) {
    case "managerGuide": {
      const hsVersion = companyInfo && companyInfo.get("hsVersion");
      const showManagerGuideTab =
        featureFlags && featureFlags.get("showManagerGuideTab");
      return (hsVersion === 5 || showManagerGuideTab) && candidateStatus === 2;
    }
    case "proctoringRecordings": {
      const platformProctoringEnabled =
        companyInfo && Boolean(companyInfo.get("platformProctoringEnabled"));

      // roleIds: 1 - Admin, 2 - Manager
      return (
        platformProctoringEnabled &&
        userData &&
        [1, 2].includes(userData.roleId) &&
        !isBulkAction
      );
    }
    default:
      return false;
  }
};
